import { Resolver, useForm } from 'react-hook-form';
import { TApplicationsContactInformationForm } from '~/store/remote-banking-contacts/types.ts';
import {
  initialFormValues,
  initialValuesManager,
  initialValuesResponsiblePersons,
} from '~/modules/remote-banking-contacts/initialValues.ts';
import {
  contactInformationValidationSchema,
  managerValidationSchema,
  responsiblePersonsValidationSchema,
} from '~/modules/remote-banking-contacts/validationSchema.ts';
import { yupResolver } from '@hookform/resolvers/yup';
import { cloneDeep } from 'lodash';
import {
  TManagerForm,
  TResponsiblePerson,
  TResponsiblePersonsForm,
} from '~/modules/remote-banking-contacts/type.ts';

export const useApplicationsContactInformationForm = () => {
  const form = useForm<TApplicationsContactInformationForm>({
    defaultValues: initialFormValues,
    resolver: yupResolver(contactInformationValidationSchema),
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });

  return form;
};

export const useManagerForm = () => {
  const resolver: Resolver<TManagerForm> = yupResolver(managerValidationSchema, {
    abortEarly: false,
  }) as Resolver<TManagerForm>;

  const form = useForm<TManagerForm>({
    defaultValues: cloneDeep(initialValuesManager),
    resolver,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });

  return form;
};

export const useResponsiblePersonsForm = (formPersons?: TResponsiblePerson[]) => {
  const initialValues = initialValuesResponsiblePersons(formPersons);

  const resolver: Resolver<TResponsiblePersonsForm> = yupResolver(
    responsiblePersonsValidationSchema,
    { abortEarly: false }
  ) as unknown as Resolver<TResponsiblePersonsForm>;

  const form = useForm<TResponsiblePersonsForm>({
    defaultValues: cloneDeep(initialValues),
    resolver,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });

  return form;
};
